"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TickIcon = void 0;
const React = __importStar(require("react"));
const TickIcon = (props) => (React.createElement("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', width: 13, height: 13, fill: 'none' }, props),
    React.createElement("circle", { cx: 6.01, cy: 6.01, r: 6.01, fill: '#E3FBDB' }),
    React.createElement("path", { stroke: '#55B844', strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: 2, d: 'M8.586 4.293 4.74 8.586 2.576 6.635' })));
exports.TickIcon = TickIcon;
